import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "icon"]

  toggle() {
    const hidden = this.rowTargets[0]?.classList.contains("hidden")
    this.rowTargets.forEach(row => row.classList.toggle("hidden"))
    this.iconTargets.forEach(icon => icon.classList.toggle("rotate-90"))
  }
}
